import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Card, Form, type FormInstance, Space, Typography } from 'antd';
import humanizeDuration from 'humanize-duration';
import type { FC } from 'react';
import { DateRangePicker } from '../BasicComponents/DateRangePicker';
import type { EventDuplicateFormFields } from './EventDuplicateModal';

const { Text } = Typography;

interface Props {
  form: FormInstance<EventDuplicateFormFields>;
}

export const NewEventTimesField: FC<Props> = ({ form }) => {
  const [newStartTime, newEndTime] = Form.useWatch('newEventTimes', form) || [];

  return (
    <>
      <Form.Item name="newEventTimes" label="Event Time Range" rules={[{ required: true }]}>
        <DateRangePicker showTime={{ format: 'HH:mm:ss' }} format="YYYY-MM-DD HH:mm:ss" />
      </Form.Item>
      {newEndTime && newStartTime && (
        <DurationCard styles={durationCardStyles}>
          <Space>
            <Text strong>Duration:</Text>

            {humanizeDuration(
              newEndTime.diff(newStartTime, ['month', 'day', 'hour', 'minute', 'second']).valueOf(),
            )}
          </Space>
        </DurationCard>
      )}
    </>
  );
};

const durationCardStyles = { body: { padding: '8px 16px' } } as const;

const DurationCard = styled(Card)`
  margin: 10px 0;
  border-color: ${RacemapColors.PaleBlue};
  max-width: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;

`;
